<template>
    <v-dialog content-class="uat-to-prd-modal" v-model="dialog" persistent :max-width="cardWidthStyle">
        <v-card class="uat-card px-5 py-8" fluid elevation="0">
            <v-row justify="center" align="center" no-gutters>
                <v-col cols="12">
                    <v-row justify="center" align="center" no-gutters>
                        <v-col cols="12" class="text-center">
                            <v-icon class="mb-5" size="100" color="red">mdi mdi-alert-circle-outline</v-icon>
                            <v-card-title class="justify-center mb-5">
                                <div>
                                    <h3 class="uat-card-header">
                                        คุณต้องการใช้งาน <span class="red--text">ระบบทดสอบ</span> ใช่หรือไม่
                                    </h3>
                                </div>
                            </v-card-title>
                            <v-card-actions>
                                <v-row justify="center" justify-md="space-between" align="center" no-gutters>
                                    <v-col cols="12" md="auto" class="go-prd mb-3 mb-md-0">
                                        <v-btn class="go-prd-btn action-btn-box white--text" color="#274C77"
                                            @click="handleClick" width="auto" height="100%" min-height="40px" depressed>
                                            ไม่ใช่ ต้องการไปยัง Production
                                            <span>({{ buttonText }})</span>
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="12" md="auto" class="stay-uat">
                                        <v-btn class="stay-uat-btn action-btn-box" color="#274C77"
                                            @click="dialog = false" width="150px" height="100%" min-height="40px"
                                            outlined depressed>
                                            ใช่
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-actions>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
</template>

<script>
import { EventBus } from '../EventBus';

export default {
    data: () => ({
        dialog: false,
        data: "",
        
    }),
    mounted() {
        EventBus.$on("open-dialog", this.openDialog)
    },
    beforeDestroy() {
        EventBus.$off("open-dialog")
    },
    computed: {
        cardWidthStyle() {
            return this.data === "go to PRD" ? "730" : "830"
        },
        buttonText() {
            return this.data === "go to PRD" ? "https://certificate.niems.go.th" : "https://certificate.niems.go.th/upload_image"
        }
    },
    methods: {
        openDialog(message) {
            this.data = message
            this.dialog = true
        },
        handleClick() {
            this.data === "go to PRD" ? this.goToPRD() : this.goToPRDUploadImg()
        },
        goToPRD() {
            location.replace('https://certificate.niems.go.th')
        },
        goToPRDUploadImg() {
            location.replace('https://certificate.niems.go.th/upload_image')
        }
    }
}
</script>

<style>
.uat-to-prd-modal {
    border-radius: 28px;
}

.uat-card {
    font-family: 'Noto Sans Thai', sans-serif;
}

.v-sheet.uat-card {
    border-radius: 28px;
}

.uat-card-header {
    font-size: 24px;
    color: #274C77;
}

.action-btn-box {
    text-transform: none;
    font-size: 14px;
    font-weight: 500;
    border-radius: 12px;
}

@media only screen and (max-width: 768px) {
    .action-btn-box.v-size--default {
        font-size: 10px;
    }
}

@media only screen and (max-width: 516px) {
    .uat-card-header span {
        display: block;
    }

    .action-btn-box:not(.v-btn--round).v-size--default {
        width: 95% !important;
        padding-top: 6px;
        padding-bottom: 6px;
    }

    .go-prd-btn span {
        display: block;
    }
}
</style>